import { render, staticRenderFns } from "./CzSegmented.vue?vue&type=template&id=2a260df0&scoped=true&"
import script from "./CzSegmented.vue?vue&type=script&lang=ts&"
export * from "./CzSegmented.vue?vue&type=script&lang=ts&"
import style0 from "./CzSegmented.vue?vue&type=style&index=0&id=2a260df0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a260df0",
  null
  
)

export default component.exports